const AUTHOR_NAME_SELECTOR = "[data-author-name], [data-author-names], a[href*='/author/']";

export function stripAuthorDesignation(value = "") {
  return value.replace(/\s*\[[^\[\]]+\]/g, "").replace(/\s+,/g, ",");
}

export function parseAuthorIdentity(value = "", location = "") {
  const normalizedValue = value.trim();
  const match = location.trim().match(/\[([^\]]+)\]/);

  return {
    name: stripAuthorDesignation(normalizedValue).trim(),
    designation: match ? match[1].trim() : "",
    location: stripAuthorDesignation(location).trim(),
  };
}

function populateAuthorProfile(profile) {
  const identity = parseAuthorIdentity(profile.dataset.authorRawName || "", profile.dataset.authorRawLocation || "");
  const firstName = identity.name.split(/\s+/)[0] || identity.name;

  profile.querySelectorAll("[data-author-profile-location]").forEach((element) => {
    element.textContent = identity.location;
  });

  profile.querySelectorAll("[data-author-profile-location-row]").forEach((element) => {
    element.hidden = !identity.location;
  });

  profile.querySelectorAll("[data-author-profile-name]").forEach((element) => {
    element.textContent = identity.name;
  });

  profile.querySelectorAll("[data-author-profile-title]").forEach((element) => {
    element.textContent = identity.designation;
  });

  profile.querySelectorAll("[data-author-profile-first-name]").forEach((element) => {
    element.textContent = firstName;
  });

  profile.querySelectorAll("[data-author-profile-image]").forEach((image) => {
    image.alt = `${identity.name} portrait`;
  });

  profile.querySelectorAll("[data-author-profile-title-row]").forEach((element) => {
    element.hidden = !identity.designation;
  });
}

function cleanAuthorNameElement(element) {
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
  const textNodes = [];

  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  textNodes.forEach((node) => {
    const cleanedValue = stripAuthorDesignation(node.nodeValue);

    if (cleanedValue !== node.nodeValue) {
      node.nodeValue = cleanedValue;
    }
  });
}

export default function initAuthorDisplayNames(root = document) {
  const targets = [];

  if (root.nodeType === Node.ELEMENT_NODE && root.matches(AUTHOR_NAME_SELECTOR)) {
    targets.push(root);
  }

  targets.push(...root.querySelectorAll(AUTHOR_NAME_SELECTOR));
  targets.forEach(cleanAuthorNameElement);

  const profiles = [];
  if (root.nodeType === Node.ELEMENT_NODE && root.matches("[data-author-profile]")) {
    profiles.push(root);
  }
  profiles.push(...root.querySelectorAll("[data-author-profile]"));
  profiles.forEach(populateAuthorProfile);

  if (root === document) {
    document.title = stripAuthorDesignation(document.title);
  }
}
